import { useEffect, useState } from 'react';

export function useScrolledPast(offset: number): boolean {
    const [isPast, setIsPast] = useState(false);

    useEffect(() => {
        let frame = 0;
        const update = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => setIsPast(window.scrollY > offset));
        };

        update();
        window.addEventListener('scroll', update, { passive: true });
        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener('scroll', update);
        };
    }, [offset]);

    return isPast;
}
